export const selectCurrentPage = (state) => state.products.page;
export const selectShowLoadMore = (state) => state.products.showLoadMore;
export const selectPods = (state) => {
  return state.products.values.filter((item) => item.defaultVariant.images.length);
};
export const selectIsFetchingProducts = (state) => state.products.pendingGetProducts;
